const Address = {
	postcode: true,
	state: true,
	city: true,
	street: true,
	building: true
};

export { Address };